export const USER_STATUS: Record<number, string> = {
  1: 'Неактивен',
  2: 'Активен',
  3: 'Отмодерирован',
  4: 'Заблокирован',
  5: 'Верифицирован',
  6: 'Деактивирован',
  7: 'Неверифицирован',
};

export const USER_STATUS_OPTIONS = [
  { value: '1', label: 'Неактивен' },
  { value: '2', label: 'Активен' },
  { value: '4', label: 'Заблокирован' },
  { value: '5', label: 'Верифицирован' },
  { value: '7', label: 'Неверифицирован' },
];

export const LOAD_STATUS_OPTIONS = [
  { value: '1', label: 'Распаршен' },
  { value: '2', label: 'Нераспаршен' },
  { value: '3', label: 'Верифицирован' },
  { value: '4', label: 'Неверифицирован' },
];

export const DEVICE_SOURCE_OPTIONS = [
  { value: 'web', label: 'Web' },
  { value: 'webview', label: 'Webview' },
  { value: 'android_app', label: 'Android' },
  { value: 'ios_app', label: 'IOS' },
  { value: 'android_web', label: 'Android Web' },
  { value: 'ios_web', label: 'IOS Web' },
];

export const PRIORITY_OPTIONS = [
  { value: '1', label: 'Только приоритетные' },
  { value: '0', label: 'Только обычные' },
];

export const SERVICE_CATEGORY_LABEL: Record<number, string> = {
  0: 'Официальный дилер',
  1: 'Сертифицированная СТО',
  2: 'Мультибрендовая НСТО',
};

export const SERVICE_CATEGORY_OPTIONS = [
  { value: '0', label: 'Официальный дилер' },
  { value: '1', label: 'Сертифицированная СТО' },
  { value: '2', label: 'Мультибрендовая НСТО' },
];

export const PARTNER_OPTIONS = [
  { value: '0', label: 'Юремонт' },
  { value: '1', label: 'GazProm' },
  { value: '2', label: 'RGS' },
  { value: '3', label: 'Bclub' },
  { value: '4', label: 'Mailru' },
  { value: '5', label: 'Autopeople' },
  { value: '6', label: 'Avito' },
  { value: '8', label: 'Carmoney' },
  { value: '9', label: 'Gruzovichkof' },
  { value: '10', label: 'carbox' },
  { value: '11', label: 'gpn_app' },
  { value: '12', label: 'gpn_bonus' },
];

export const SEARCH_KEY_OPTIONS = [
  { value: 'id', label: 'Поиск по id' },
  { value: 'name', label: 'Поиск по имени' },
  { value: 'phone', label: 'Поиск по телефону' },
  { value: 'email', label: 'Поиск по email' },
];

export function mapLoadStatus(loadStatus: string): {
  isParsed: string | number;
  isVerified: string | number;
} {
  switch (loadStatus) {
    case '1':
      return { isParsed: 1, isVerified: '' };
    case '2':
      return { isParsed: 0, isVerified: '' };
    case '3':
      return { isParsed: '', isVerified: 1 };
    case '4':
      return { isParsed: '', isVerified: 0 };
    default:
      return { isParsed: '', isVerified: '' };
  }
}

export const RECEIVE_TYPE_OPTIONS = [
  { value: '1', label: 'Только звонки' },
  { value: '2', label: 'Только заявки' },
  { value: '3', label: 'Звонки + заявки' },
];

export const SERVICE_DISCOUNT_OPTIONS = [
  { value: '1', label: 'Скидка на работы' },
  { value: '2', label: 'Скидка на весь чек' },
  { value: '0', label: 'Выкл' },
];

export const DISCOUNT_LEVEL_MODE_OPTIONS = [
  { value: '0', label: 'Авто' },
  { value: '1', label: 'Вручную' },
];

export const DISCOUNT_LEVEL_OPTIONS = [
  { value: '1', label: 'Базовый' },
  { value: '2', label: 'Продвинутый' },
  { value: '3', label: 'Максимальный' },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: '2', label: 'Предоплата' },
  { value: '3', label: 'Постоплата' },
];
